import React from 'react';
import PropTypes from 'prop-types';
import Button from '@style-guide/components/Button';
import MobileButtons from './components/MobileButtons';
import DesktopButtons from './components/DesktopButtons';
import Wrapper from './components/Wrapper';
import TabButton from './components/TabButton';
import ButtonWrapper from './components/ButtonWrapper';
import TabButtonWrapper from './components/TabButtonWrapper';

const TabMenu = ({
  activeTab,
  updateTabState,
  courseMaterialsExist,
}) => (
  <Wrapper>
    <MobileButtons>
      <ButtonWrapper>
        <Button
          onClick={() => updateTabState('courseDetails')}
          variant={activeTab === 'courseDetails' ? 'primary' : 'ghost'}
          style={{
            width: '100%',
          }}
        >
          Meeting Details
        </Button>
      </ButtonWrapper>
      {courseMaterialsExist && (
        <ButtonWrapper>
          <Button
            onClick={() => updateTabState('courseMaterials')}
            variant={activeTab === 'courseMaterials' ? 'primary' : 'ghost'}
            style={{
              width: '100%',
            }}
          >
            Meeting Materials
          </Button>
        </ButtonWrapper>
      )}
    </MobileButtons>
    <DesktopButtons>
      <TabButtonWrapper>
        <TabButton
          onClick={() => updateTabState('courseDetails')}
          $active={activeTab === 'courseDetails'}
        >
          Meeting Details
        </TabButton>
      </TabButtonWrapper>
      {courseMaterialsExist && (
        <TabButtonWrapper>
          <TabButton
            onClick={() => updateTabState('courseMaterials')}
            $active={activeTab === 'courseMaterials'}
          >
            Meeting Materials
          </TabButton>
        </TabButtonWrapper>
      )}
    </DesktopButtons>
  </Wrapper>
);

TabMenu.propTypes = {
  updateTabState: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  courseMaterialsExist: PropTypes.bool.isRequired,
};

TabMenu.displayName = 'TabMenu';

export default TabMenu;
